import {
    CLEAN_SUBMITTING,
    DISABLE_ENABLE_FIELDS,
    ENABLE_ALL_FIELDS,
    SET_CREDENCIAL,
    SET_LOADING,
    SET_MESSAGE,
    SET_MODULES,
    SET_SELECT_OPTIONS,
    SET_SHOW_HEADER,
    SET_SUBMITTING,
    SET_SUBMITTING_PROGRESS
} from './actionTypes.js';
import {MESSAGE_ERROR, URL_MODULOS} from '../constants/index.js';
import * as Async from '../features/async.js';

export const setLoading = isLoading => {
    return (dispatch, getState) => {
        const {
            embedded
        } = getState();

        if (embedded) {
            parent.postMessage(isLoading ? 'showLoading' : 'hideLoading', "*");
        } else {
            dispatch(_setLoading(isLoading));
        }
    };
};

export const _setLoading = isLoading => ({
    type: SET_LOADING,
    isLoading
});

export const sendMessage = (typeMessage, text) => ({
    type: SET_MESSAGE,
    typeMessage,
    text
});

export const setCredencial = credencial => ({
    type: SET_CREDENCIAL,
    credencial: encodeURIComponent(credencial)
});

export const setShowHeader = showHeader => ({
    type: SET_SHOW_HEADER,
    showHeader
});

export const fetchModules = ({force = false} = {}) => {
    return (dispatch, getState) => {
        const {
            credencial,
            modules
        } = getState();

        if (!force && modules && modules.length) {
            return Promise.resolve(modules);
        }

        // Sem setLoading: o ModuloAdministrativo mostra o próprio loader enquanto os módulos carregam.
        return Async.fetch(URL_MODULOS, credencial).then(modules => {
            dispatch(setModules(modules));
        }).catch(handleError(dispatch));
    };
};

export const setModules = modules => ({
    type: SET_MODULES,
    modules
});

export const setSelectOptions = options => ({
    type: SET_SELECT_OPTIONS,
    options
});

export const setCampusOptions = campusOptions => setSelectOptions({campusOptions});

export const setCursoOptions = cursoOptions => setSelectOptions({cursoOptions});

export const setCampusSelecionado = campusSelecionado => setSelectOptions({campusSelecionado});

export const setCursoSelecionado = cursoSelecionado => setSelectOptions({cursoSelecionado});

export const setAnoSelecionado = anoSelecionado => setSelectOptions({anoSelecionado});

export const setSemestreSelecionado = semestreSelecionado => setSelectOptions({semestreSelecionado});

export const disableEnableFields = payload => ({
    type: DISABLE_ENABLE_FIELDS,
    payload
});

export const enableAllFields = payload => ({
    type: ENABLE_ALL_FIELDS
});

const _setSubmitting = isSubmitting => ({
    type: SET_SUBMITTING,
    isSubmitting
});

const _setSubmittingProgress = progress => ({
    type: SET_SUBMITTING_PROGRESS,
    progress
});

const _cleanSubmitting = () => ({
    type: CLEAN_SUBMITTING
});

export const handleError = dispatch => error => {
    const errorMessage = error.mensagem || error;

    dispatch(setLoading(false));
    dispatch(sendMessage(MESSAGE_ERROR, errorMessage));

    if (error.detalhe) {
        console.log(error.detalhe);
    } else {
        console.log(errorMessage);
    }

    return Promise.reject(errorMessage);
};
